// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { SystemListCollectionModel, SystemListModel } from "@west/App/Services/SystemListService";
import { Draft } from "immer";

export type SystemListState = {
    [key: string]: SystemListModel[] | undefined;
};

const initialSystemListState: SystemListState = {};

const reducer = {
    "xSystemLists/CompleteLoadSystemList": (
        draft: Draft<SystemListState>,
        action: { data: SystemListCollectionModel },
    ) => {
        Object.keys(action.data.systemList).forEach((key: string) => {
            draft[key] = action.data.systemList[key];
        });
    },
};

const xSystemList = createTypedReducerWithImmer(initialSystemListState, reducer);

(reducers as any).xSystemList = xSystemList;

export type xSystemListState = {
    xSystemList: SystemListState;
} & ApplicationState;

type xSystemListReducers = {
    systemList: typeof xSystemList;
};

export type xSystemListActions = Parameters<xSystemListReducers[keyof xSystemListReducers]>[1] | AnyAction;
